export const getNewsletterSignupApiUrl = () => {
  return '/newsletter/signup'
}
